import React, { Component } from 'react';
import './new-post.style.css';




import 'codemirror/lib/codemirror.css'; // Editor's Dependency Style
import 'highlight.js/styles/github.css';
import 'tui-color-picker/dist/tui-color-picker.css';
import '@toast-ui/editor/dist/toastui-editor.css'; // Editor's Style


import { Editor, Viewer } from "@toast-ui/react-editor";
import colorSyntaxPlugin from "@toast-ui/editor-plugin-color-syntax";
import hljs from "highlight.js";
import codeSyntaxHighlightPlugin from "@toast-ui/editor-plugin-code-syntax-highlight";



import axios from 'axios'
import UserContext from '../../utils/userContext'
import { PostCover, PostAuthor, PostDetail } from '../content-card/content-card.component';
import { ReferenceViewer } from '../content-card/content-card.component'
import ReCAPTCHA from "react-google-recaptcha";

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Autosuggest from 'react-autosuggest';

import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';

import { Modal } from '../modal/modal.component';

import {
    Link, Redirect
} from 'react-router-dom'


library.add(fas);


const EachReference = (props) => {

    return (
        <div className="ref-each">
            <div className="ref-data">
                <div className="ellipsis-text">{props.idx + 1}. {props.refTitle}</div>
                <div className="ellipsis-text">จาก. {props.refUrl}</div>
            </div>
            <div className="ref-remove-wrap">
                <div>
                    <button className="ref-remove" data-key={props.idx} onClick={props.removeReference}>x</button>
                </div>
            </div>
        </div>
    )
}

const ReferenceSegments = (props) => {

    return (
        <div className="ref-wrap">
            <div>
                <input className="ref-input" id="refText" placeholder="ชื่อแหล่งสืบค้น" value={props.refText} onChange={props.refTextChange} />
                <input className="ref-input" id="refSource" placeholder="ลิงก์เว็บไซต์" value={props.refSource} onChange={props.refSourceChange} />
            </div>
            <div className="ref-input-submit" type="submit" onClick={props.refUpdateRef}>เพิ่ม</div>
        </div>
    )
}


const CoverImageAdd = (props) => {
    return (
        <>
            <label for="cover-image">
                {props.coverImage != "" ?
                    <div className="post-cover post-cover-upload" style={{ backgroundImage: `url(${props.coverImage})` }}></div>
                    :
                    <div className="post-cover post-cover-upload" ><FontAwesomeIcon className="cover-icon" icon={['fas', 'image']} /><div className="cover-text">คลิกที่นี่เพื่อใส่รูปของคุณ</div></div>
                }
            </label>
            <input style={{ width: '0px', height: '0px', overflow: 'hidden' }} id="cover-image" name="cover-image" type="file" accept="image/*" onChange={props.onUpload} />
        </>
    )
}



export default class PostEditor extends Component {
    editorRef = React.createRef();
    static contextType = UserContext

    constructor(props) {
        super(props);
        this.state = {
            form: {
                title: "",
                tags: [],
                coverImage: "",
                content: "",
                status: "public",
                references: [],
                captcha: null
            },

            refText: "",
            refSource: "",
            getContentTrigger: false,
            counter: 0,
            previewMode: false,
            imgText: "",
            modalConfirmAction: false,


        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleTagChange = this.handleTagChange.bind(this);

        this.handleTagInput = this.handleTagInput.bind(this);
        this.removeTag = this.removeTag.bind(this);

        this.handleEditorChange = this.handleEditorChange.bind(this);

        this.handleRefTitleChange = this.handleRefTitleChange.bind(this);
        this.handleRefUrlChange = this.handleRefUrlChange.bind(this);

        this.refTextChange = this.refTextChange.bind(this);
        this.refSourceChange = this.refSourceChange.bind(this);
        this.refUpdateRef = this.refUpdateRef.bind(this);



        this.removeReference = this.removeReference.bind(this);
        this.handleUploadCoverImage = this.handleUploadCoverImage.bind(this)
        this.onAddImageBlob = this.onAddImageBlob.bind(this)
        this.addRef = this.addRef.bind(this)

        this.onShowModal = this.onShowModal.bind(this)
        this.closeModal = this.closeModal.bind(this)

        this.onDeletePost = this.onDeletePost.bind(this)
        this.savePost = this.savePost.bind(this)

        this.onSuccessCaptcha = this.onSuccessCaptcha.bind(this)

    }







    componentDidMount() {
        if (this.props.action === "edit") {

            var self = this;

            axios({
                method: 'get',
                url: `https://www.borntodev.com/wp-json/devblog/v1/posts/user/${this.context.userData.nicename}/${self.props.contentId}`,
                headers: {
                    'Content-Type': 'multipart/form-data',

                }
            })
                .then(function (response) {
                    // self.editorRef.current.setMarkdown(response.data.content)

                    let contentData = response.data;
                    contentData['captcha'] = null

                    self.editorRef.current.getInstance().setMarkdown(response.data.content)
                    self.setState({ form: contentData })

                })
                .catch(function (response) {

                    self.props.history.push("/404/")

                });

        }
    }

    handleInputChange(event) {
        this.setState({
            form: { ...this.state.form, [event.target.name]: event.target.value }
        }, () => {  })
    }

    handleTagChange(event) {

        this.setState({
            form: { ...this.state.form, tags: event.target.value.split(", ") }
        }, () => {  })
    }

    handleTagInput(tagData) {
        let tags = this.state.form.tags;
        tags.push(tagData)
        this.setState({ form: { ...this.state.form, tags: tags } })
    }

    handleRefTitleChange(event) {
        let references = [...this.state.form.references]
        references[event.target.getAttribute('data-key')].title = event.target.value
        this.setState({
            form: { ...this.state.form, references: references }
        })
    }

    handleRefUrlChange(event) {
        let references = [...this.state.form.references]
        references[event.target.getAttribute('data-key')].url = event.target.value
        this.setState({
            form: { ...this.state.form, references: references }
        })
    }

    refTextChange(event) {
        this.setState({ refText: event.target.value })
    }

    refSourceChange(event) {

        this.setState({ refSource: event.target.value })
    }

    refUpdateRef() {
        if (this.state.refText !== "" && this.state.refSource !== "") {
            let refAdded = this.state.form.references;
            refAdded.push({ title: this.state.refText, url: this.state.refSource })
            this.setState({ form: { ...this.state.form, references: refAdded }, refText: "", refSource: "" });
        }
    }

    handleUploadCoverImage(event) {
        if (event.target.files.length > 0) {
            if (((event.target.files[0].size / 1024) / 1024).toFixed(4) <= 2) {
                this.setState({ imgText: "" })
                this.uploadImage(event.target.files[0])
                    .then(response => {
                        if (!response.success) {
                            throw new Error('Validation error');
                        }
                        this.setState({
                            form: { ...this.state.form, coverImage: response.data.url }

                        })
                    }).catch(error => {
                        // console.log(error);
                    });
            } else {
                this.setState({ imgText: "ไม่สามารถอัปไฟล์รูปที่มีขนาดเกิน 250 Kb ได้" })
            }
        }

    }

    handleEditorChange() {
        let formSave = this.state.form;
        // console.log(this.editorRef.current.getInstance().getSelectedText())
        // formSave['contentText'] = this.editorRef.current.getInstance().getTextObject()._range.commonAncestorContainer.ownerDocument.activeElement.textContent;
        formSave['content'] = this.editorRef.current.getInstance().getMarkdown();



        this.setState({
            form: formSave

        }, () => {
            // console.log(this.state.form);
        })
    }

    removeReference(event) {
        let reference = [...this.state.form.references]
        reference.splice(event.target.getAttribute('data-key'), 1);
        this.setState({
            form: { ...this.state.form, references: reference }
        })
    }

    removeTag(event) {
        let tag = [...this.state.form.tags]
        tag.splice(event.target.getAttribute('data-key'), 1);
        this.setState({
            form: { ...this.state.form, tags: tag }
        })
    }






    savePost() {

        const status = this.state.modalConfirmAction
        let self = this
        let requestUrl = 'https://www.borntodev.com/wp-json/devblog/v1/posts/'
        let requestMethod = 'post'

        if (this.props.action === "edit") {
            requestMethod = 'put'
        }

        let form = this.state.form;
        // console.log(des)
        form['status'] = status;

        let htmlText = this.editorRef.current.getInstance().getHtml();

        var htmlFilteredText = htmlText.replace(/<[^>]*>?/gm, '');

        let des = htmlFilteredText.replace(/\r?\n|\r/g, '')

        form['contentText'] = des;


        form.tags = form.tags.map((x) => x.tagName)


        let formData = {
            "contentId": this.state.form.contentId,
            "postData": (form)
        }

        return axios({
            method: requestMethod,
            url: requestUrl,
            data: formData,
            headers: {
                'Content-Type': 'application/json',

            }
        })
            .then(function (response) {
                self.props.history.push(`/${self.context.userData.nicename}`)
            })
            .catch(function (response) {
                return response.data;
            });
    }


    uploadImage(blob) {
        let formData = new FormData();
        formData.append('image', blob);

        return axios({
            method: 'post',
            url: 'https://www.borntodev.com/wp-json/devblog/v1/images',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',

            }
        })
            .then(function (response) {
                return response.data;
            })
            .catch(function (response) {
                return response.data;
            });
    };

    onAddImageBlob(blob, callback, source) {
        // console.log(blob)
        this.uploadImage(blob)
            .then(response => {
                if (!response.success) {
                    throw new Error('Validation error');
                }

                callback(response.data.url);
            }).catch(error => {
                // console.log(error);
            });
    };

    addRef() {
        let refAdded = this.state.form.references;
        refAdded.push({ title: "", url: "" })
        this.setState({ form: { ...this.state.form, references: refAdded } });
    }



    changePageMode() {
        this.setState(prevState => ({ previewMode: !prevState.previewMode }))
    }


    onSuccessCaptcha(code) {
        this.setState({ form: { ...this.state.form, captcha: code } });
    }




    onDeletePost() {
        var self = this;

        axios({
            method: 'delete',
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/`,
            data: { "contentId": this.state.form.contentId },
            headers: {
                'Content-Type': 'multipart/form-data',

            }
        })
            .then(function (response) {
                self.props.history.push(`/${self.context.userData.nicename}`)
            })
            .catch(function (response) {
            });
    }

    closeModal() {
        this.setState({ modalConfirmAction: false })
    }

    onShowModal(action) {
        this.setState({ modalConfirmAction: action })
    }

    genConfirmComponent(action) {

        return <ConfirmModal action={action} confirmAction={action === "delete" ? this.onDeletePost : action === "empty" ? this.closeModal : this.savePost} cancelAction={this.closeModal} />
    }

    publishPost() {


        const form = this.state.form;
        if (form.title && form.tags.length && form.content && form.references.length && form.captcha) {
            this.onShowModal("public")
        } else {
            this.onShowModal("empty")
        }

    }

    draftPost() {

        const form = this.state.form;
        if (form.title && form.tags.length && form.content && form.references.length && form.captcha) {
            this.onShowModal("draft")
        } else {
            this.onShowModal("empty")
        }
    }

    onDeleteRequest() {
        this.onShowModal("delete")
    }


    render() {
        return (
            <div className="content-wrap inner-bg-color">
                {this.context.userData.loggedIn ? "" : <Redirect to="/404/" />}



                <div className="card-wrap">
                    {this.state.previewMode ?
                        <PreviewModeEditor
                            changeMode={this.changePageMode.bind(this)}

                            form={this.state.form}

                            authorImage={this.context.userData.profileImage}
                            authorName={this.context.userData.displayName}

                            editorRef={this.editorRef}
                        />
                        :



                        <EditModeEditor
                            changeMode={this.changePageMode.bind(this)}

                            form={this.state.form}

                            tagInput={this.handleTagInput}
                            tagRemove={this.removeTag}

                            editorRef={this.editorRef}

                            titleOnChange={this.handleInputChange}



                            coverOnUpload={this.handleUploadCoverImage}

                            contentOnChange={this.handleEditorChange}
                            contentOnAddImageBlobHook={this.onAddImageBlob}

                            refAddRef={this.addRef}
                            refOnRefTitleChange={this.handleRefTitleChange}
                            refOnRefUrlChange={this.handleRefUrlChange}
                            refRemoveReference={this.removeReference}

                            refTextChange={this.refTextChange}
                            refSourceChange={this.refSourceChange}
                            refUpdateRef={this.refUpdateRef}

                            refText={this.state.refText}
                            refSource={this.state.refSource}

                        />

                    }
                    <div className="final-action-wrap">
                        {this.state.modalConfirmAction ? <Modal showModal={this.closeModal} modalComponent={this.genConfirmComponent(this.state.modalConfirmAction)} /> : ""}

                        <div className="flex del-cap-item-center">
                            <div>
                            {this.props.action === "edit" ? <div className="delete-post-button delete-post" onClick={this.onDeleteRequest.bind(this)}><FontAwesomeIcon icon={['fas', 'trash-alt']} /></div> : <></>}
                            </div>

                            <ReCAPTCHA
                                sitekey="6LfOJcYZAAAAALUvkaI-d_IIW57WSkGV2_g46quL"
                                onChange={this.onSuccessCaptcha}
                            />
                        </div>
                        <div className="fa-saves">
                            <div className="save-button save-public" onClick={this.publishPost.bind(this)}>Publish</div>
                            <div className="save-button save-draft" onClick={this.draftPost.bind(this)}>Save Draft</div>
                        </div>

                    </div>

                </div>
            </div>
        )
    }
}

const ConfirmModal = (props) => {
    const modalTheme = {
        "delete":
        {
            "quote": <>ต้องการ<span style={{ color: "#A60404" }}>ลบ</span>โพส?</>,
            "color": "#A60404"
        },
        "public": {
            "quote": <><span style={{ color: "#04A645" }}>เผยแพร่</span>โพสนี้?</>,
            "color": "#04A645"
        },
        "draft": {
            "quote": "ต้องการบันทึกฉบับร่าง?",
            "color": "#3C3C3C"
        },
        "empty": {
            "quote": "คุณยังกรอกข้อมูลไม่ครบ!",
            "color": 'darkcyan'
        }
    }
    return (
        <div className="editor-confirm-modal">
            <div className="ecm-header">{modalTheme[props.action]["quote"]}</div>
            <div className="ecm-button-segment">
                <div className="ecm-button ecm-confirm" style={{ backgroundColor: modalTheme[props.action]["color"] }} onClick={props.confirmAction}>
                    ตกลง
                </div>
                <div className="ecm-button ecm-cancel" onClick={props.cancelAction}>
                    ยกเลิก
                </div>
            </div>
        </div>
    )
}

const NewPost = (props) => {
    return (
        <PostEditor action={"create"} history={props.history} />
    )

}

const PreviewModeEditor = (props) => (
    <div className="content-preview-wrap">
        <div className="button-swap-preview" onClick={props.changeMode}>คลิกที่นี่เพื่อออกจากโหมดตัวอย่าง </div>
        <div className="content-card" style={{ marginTop: "30px" }}>
            <PostCover coverImage={props.form.coverImage} />
            <PostAuthor authorImage={props.authorImage} authorName={props.authorName} date={(new Date()).toDateString()} />
            <PostDetail title={props.form.title} miniheartCount={0} commentCount={0} tags={props.form.tags} />
            <div className="post-detail">
                <div className="post-content">
                    <Viewer
                        previewStyle="vertical"
                        initialValue={props.form.content}
                        ref={props.editorRef}
                        plugins={[[codeSyntaxHighlightPlugin, { hljs }], colorSyntaxPlugin]}
                    />
                    <h3>Reference</h3>
                    {
                        props.form.references.map((eachRef, i) => <ReferenceViewer key={i} refTitle={eachRef.title} refUrl={eachRef.url} />)
                    }
                </div>
            </div>
        </div>
    </div>
)

const EditModeEditor = (props) => (
    <div>

        <div className="new-p-wrap">
            <CoverImageAdd onUpload={props.coverOnUpload} coverImage={props.form.coverImage} />

            <div className="new-q-content">
                <div className="flex">
                    <div className="title-edit-wrap">
                        <input
                            className="title-edit"
                            id="post-title"
                            name="title"
                            type="text"
                            placeholder="เพิ่มชื่อหัวข้อของคุณ"
                            onChange={props.titleOnChange}
                            value={props.form.title}
                        />
                    </div>
                    <div className="post-example-button ellipsis-text" onClick={props.changeMode}>
                        ดูตัวอย่างโพสต์
                    </div>

                </div>

                <br />
                <TagEditor tagInput={props.tagInput} />
                <TagPreview tags={props.form.tags} tagRemove={props.tagRemove} />

                <div id="content-editor">
                    <Editor
                        previewStyle="vertical"
                        height="500px"
                        initialValue={props.form.content}
                        ref={props.editorRef}
                        onChange={props.contentOnChange}
                        onAddImageBlobHook={props.contentOnAddImageBlobHook}
                        initialEditType="wysiwyg"
                        plugins={[[codeSyntaxHighlightPlugin, { hljs }], colorSyntaxPlugin]}
                    />
                </div>

                <div className="editor-ref-header">การอ้างอิง</div>
                <ReferenceSegments refUpdateRef={props.refUpdateRef} refTextChange={props.refTextChange} refSourceChange={props.refSourceChange} refText={props.refText} refSource={props.refSource} />
                {props.form.references.map((refData, idx) => <EachReference key={idx} idx={idx} refUrl={refData.url} refTitle={refData.title} removeReference={props.refRemoveReference} />)}

            </div>
        </div>

    </div>
)







function getSuggestionValue(suggestion) {
    return `${suggestion.tagName}`;
}

function renderSuggestion(suggestion, { query }) {
    const suggestionText = `${suggestion.tagName}`;
    const matches = AutosuggestHighlightMatch(suggestionText, query);
    const parts = AutosuggestHighlightParse(suggestionText, matches);

    return (
        <div className='suggestion-content' style={{ backgroundImage: `url(${suggestion.tagLogo})` }}>
            <div className="name">
                {
                    parts.map((part, index) => {
                        const className = part.highlight ? 'highlight' : null;

                        return (
                            <span className={className} key={index}>{part.text}</span>
                        );
                    })
                }
            </div>
        </div>
    );
}

class TagEditor extends React.Component {
    static contextType = UserContext
    constructor() {
        super();

        this.state = {
            value: '',
            suggestList: []
        };
        this.onTagAdd = this.onTagAdd.bind(this)
    }



    onSuggestionsFetchRequested = ({ value }) => {



        if (value === "") {
            this.setState({ suggestList: [] })
        } else {
            const self = this;

            axios({
                method: 'get',
                url: `https://www.borntodev.com/wp-json/devblog/v1/tags/search?q=${value}`,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(function (response) {

                    self.setState({ suggestList: response.data.suggestedTags })
                })
                .catch(function (response) {

                });

        }
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestList: []
        });
    };

    onTagAdd = () => {
        const tag = this.state.value;
        if (tag !== "") {
            const self = this;
            axios({
                method: 'get',
                url: `https://www.borntodev.com/wp-json/devblog/v1/tags/detail?q=${tag}`,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(function (response) {
                    if (response.data.success) {
                        self.props.tagInput(response.data.tagData)
                    } else {
                        const tagData = { "tagName": tag, "officialTag": "0", "tagLogo": "", "tagDescription": "", "tagLink": "", "tagColor1": "#3C3C3C", "tagColor2": "white" }
                        self.props.tagInput(tagData)
                    }
                    self.setState({ value: "" })

                })
                .catch(function (response) {

                });
        }
    }

    onChange = (event, { newValue, method }) => {

        var tag = newValue;
        var filteredTag = tag.replace(/[^a-z0-9_]/gi, '').replace('&nbsp;', ' ');


        this.setState({
            value: filteredTag
        });

    };

    render() {
        const { value, suggestList } = this.state;
        const inputProps = {
            placeholder: "เพิ่มแท็กของคุณ (สูงสุด 5)",
            value,
            onChange: this.onChange
        };

        return (
            <div className="flex">
                <div>
                    <Autosuggest
                        suggestions={suggestList}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={getSuggestionValue}
                        renderSuggestion={renderSuggestion}
                        inputProps={inputProps} />
                </div>
                <div className="tag-add" onClick={this.onTagAdd}>เพิ่ม</div>
            </div>
        );
    }
}

const TagPreview = (props) => {

    return (
        <div className="tags-preview">
            {props.tags.map((tag, i) => <EachTagPreview key={i} idx={i} tag={tag} tagRemove={props.tagRemove} />)}
        </div>
    )
}

const EachTagPreview = (props) => {

    const tagStyle = props.tag.officialTag === "1" ? { backgroundColor: props.tag.tagColor1, color: props.tag.tagColor2 } : { backgroundColor: "#3C3C3C", color: "white" }

    return (
        <div className="tag-preview" data-key={props.idx} style={tagStyle} onClick={props.tagRemove}>{props.tag.tagName}</div>
    )
}






export { NewPost };
